import { jsx } from "react/jsx-runtime";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { fontWeight } from "../../css/typography.css.mjs";
const Strong = ({ children, data, id, ...restProps }) => /* @__PURE__ */ jsx(
  "strong",
  {
    className: fontWeight.strong,
    id,
    ...buildDataAttributes({ data, validateRestProps: restProps }),
    children
  }
);
export {
  Strong
};
